import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import Home from './pages/Home';
import Services from './pages/Services';
import About from './pages/About';
import PackagesPricingPage from './pages/PackagesPricing';
import Contact from './pages/Contact';
import CreditRepairLanding from './pages/CreditRepairLanding';
import Policies from './pages/Policies';
import enTranslations from './translations/en';
import esTranslations from './translations/es';
import PrivacyPolicyEN from './pages/PrivacyPolicyEN';
import Unsubscribe from './pages/Unsubscribe';

function App() {
  const [language, setLanguage] = useState('en'); // idioma por defecto
  const [translations, setTranslations] = useState(enTranslations);

  useEffect(() => {
    if (language === 'en') {
      setTranslations(enTranslations);
    } else {
      setTranslations(esTranslations);
    }
  }, [language]);

  const handleLanguageChange = (lang) => {
    setLanguage(lang);
  };

  return (
    <Router>
      <div className="bg-fut-bg-dark text-fut-text-light font-sans">
        <Header onLanguageChange={handleLanguageChange} />

        <Routes>
          <Route path="/" element={<Home translations={translations} />} />
          <Route path="/services" element={<Services translations={translations} />} />
          <Route path="/services/credit-repair" element={<CreditRepairLanding translations={translations} />} />
          <Route path="/about" element={<About translations={translations} />} />
          <Route path="/contact" element={<Contact translations={translations} />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyEN />} />
          <Route path="/policies" element={<Policies translations={translations} />} />
          <Route path="/unsubscribe" element={<Unsubscribe />} />

          {/* ✅ Aquí va la página de Paquetes & Precios */}
          <Route
            path="/packages"
            element={<PackagesPricingPage lang={language} />}
          />
        </Routes>

        <WhatsAppButton translations={translations} />
        <Footer translations={translations} />
      </div>
    </Router>
  );
}

export default App;

